import { get_token, get_user_details } from "@/router";
import Swal from 'sweetalert2';
import Quill from 'quill';
import 'quill/dist/quill.snow.css';
import 'quill-mention';
import Multiselect from 'vue-multiselect'
import 'vue-multiselect/dist/vue-multiselect.min.css'
import { client_domain } from "@/main.js";

export default {
  components: {
    Multiselect,
  },
  data() {
    return ({
      selected_author: null,
      authorInput: '',
      isAuthorModalOpenedFromFeed: false,
      linkPreview: null,
      token_exists: false,
      user_details: {
        "user_role": '',
        "user_id": '',
        "first_name": '',
        "last_name": '',
      },
      tagged_users: [],
      temporaryPost: null,
      temporary_hub_post: null,
      isSubmitting: false,
      isDropdownVisible: false,
      fileName: '',
      imagePreview: null,
      videoPreview: null,
      topics: [],
      created_by_id: this.created_by,
      portals: [],
      isMaster: false,
      selectedPortals: [],
      selectedMasterPortal: '',
      selectedPortalId: null,
      selectedTopicId: null,
      selectedVisibility: 'public',
      searchQuery: "",
      errors: {
        audio_file: null,
        portal: null,
        segment: null,
        report_description: null
      },
      users: [],
      selectedUserIds: [],
      portal_users: [],
      isRecording: false,
      audio_file: null,
      audio_attachments: [],
      mediaRecorder: null,
      recordedChunks: [],
      audio_file_name: '',
      upload_media: null,
      fileError: '',
      audioError: '',
      comments_off: true,
      showSuggestions: false,
      currentTagPosition: -1,
      portal_types: [],
      selectedPortalType: null,
      payload: {},
      cbo_domain: false,
      dwypd_domain: false,
      soulcity_domain: false,
      visible_domain: false,
      members: [],
      authorName: '',
      authorLink: '',
      authors: [],
      grouped_tags: {},      // Use object if you're looping via (tags, category)
      selected_tags: new Map(),
      selected_categories: [],
      isCategoryModalOpenedFromFeed: false,
      recordingTime: 0,
      timerInterval: null,
      primary_tags: new Map(),
      showAllPrimary: false,
      showAllSecondary: false,
      previews: [],
      upload_files: [],
      report_edit: {},
      edit_report_id: null,
      edit_report_description: '',
      edit_report_link: '',
      edit_documents: {},
      edit_selected_topic: null,
      edit_authors: [],
      edit_author_input: '',
      edit_author_link: '',
      edit_selected_tags: new Map(),
      edit_primary_tags: new Map(),
      edit_primary_tag: null,
      edit_selected_categories: [],
      edit_files_to_remove: [],
      edit_previews: [],
      edit_upload_files: [],
      edit_isDragging: false,
      edit_comments_off: true,
      quillContentLength: 0,
      isDragging: false,
      file_input_key: 0,
      edit_file_input_key: 0,
      audio_input_key: 0,

    });
  },
  props: {
    group_id: {
      type: String,
      required: false,
      default: null
    },
    created_by: {
      type: String,
      required: false,
      default: null
    },
    is_public: {
      type: Boolean,
      default: false,
    },
    current_portal_permissions: {
      type: Array,
      default: () => []
    },
    activeProfile: { type: Object, default: null },
    companyName: {
      type: String,
      default: null,
      required: false,
    },
    profileName: {
      type: String,
      default: null,
      required: false,
    },
  },

  mounted() {
    this.token_exists = get_token();
    this.user_details = get_user_details();
    if (client_domain.includes('tdm') || client_domain.includes('chamber') || client_domain.includes('cbo') || client_domain.includes('demo') ||
      client_domain.includes('engagenet') || client_domain.includes('dwypd') || client_domain.includes('bosa')) {
      this.visible_domain = true;
    }

    if (client_domain.includes('dwypd') || client_domain.includes('soulcity') || client_domain.includes('nsp') || client_domain.includes('engagenet')) {
      this.dwypd_domain = true;
      this.fetch_grouped_tags();
    }
    this.$nextTick(() => {
      this.initQuillEditor();
    });

    if (this.$route.name === 'view_incidents') {
      this.payload = {
        filter_values: {
          portal_type__name: 'incident'
        }
      }
    }
    else {
      this.payload = {}
    }
    const feedModal = $('#feed_modal');
    feedModal.on('show.bs.modal', () => {
      // 🚨 Only reset if not coming from category modal
      if (!this.isCategoryModalOpenedFromFeed) {
        this.resetPortalSelection();

        const quill = this.$refs.quillReportEditorRef?.quill;
        if (quill) {
          quill.setText('');
        }

        this.currentTagPosition = null;
        this.searchQuery = '';
        this.showSuggestions = false;

        if (this.$route.name === 'home' || this.$route.name === 'view_topic' || this.$route.name === 'home_filter' || this.$route.name === 'customer_profile') {
          this.fetchPortals();
        }

        if (this.$route.name === 'view_portal') {
          this.selectedPortalId = this.$route.params.portal_id;
          this.fetch_topics(this.selectedPortalId);
        } else {
          this.fetch_topics();
        }
      } else {
        // Reset the flag after the modal is shown again
        this.isCategoryModalOpenedFromFeed = false;
      }
    });
    // Ensure recording is stopped when the modal is hidden/dismissed
    feedModal.on('hide.bs.modal', () => {
      // If the user navigates to category/author modal we still want to stop any active recording
      try {
        this.cleanupRecording(true); // discard any in-progress recording for privacy
      } catch (e) {
        // ignore cleanup errors on modal hide
      }
    });



    if (client_domain.includes('cbo')) {
      this.cbo_domain = true;
    }

    if (client_domain.includes('soulcity') || client_domain.includes('nsp')) {
      this.soulcity_domain = true;
    }
  },
  watch: {
    '$route.params.portal_id'() {
      this.fetch_users();
    },

  },

  computed: {
    is_post_empty() {
      const has_text = this.quillContentLength > 0;
      const has_media = this.previews.length > 0;
      const has_audio = this.audio_attachments.length > 0;
      const has_link = !!this.linkPreview;

      return !(has_text || has_media || has_audio || has_link);
    },

    profileImage() {
      const type = this.activeProfile
      if (type?.profile_type === 'personal') {
        return this.getPersonalProfileImage()
      }
      if (type?.profile_type === 'business') {
        return this.getBusinessProfileImage()
      }

      return null
    },
    composer_display_name() {
      if (this.$route.path.includes('profile')) {
        return this.companyName || this.profileName || 'there';
      }

      if (this.activeProfile?.company?.company_name) {
        return this.activeProfile.company.company_name;
      }

      return this.activeProfile?.user?.first_name || this.user_details.first_name || 'there';
    },

    formattedTime() {
      const minutes = Math.floor(this.recordingTime / 60);
      const seconds = this.recordingTime % 60;
      return `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
    },
    Edit_selected_tags() {
      let tags = [];
      this.edit_selected_tags.forEach(arr => {
        tags.push(...arr);
      });
      if (this.edit_primary_tag) {
        const primaryId = this.edit_primary_tag.id;
        tags = [
          {
            id: this.edit_primary_tag.id,
            name: this.edit_primary_tag.name
          },
          ...tags.filter(t => t.id !== primaryId)
        ];
      }
      return tags;
    },
    selectedPortalTopics() {
      if (!this.selectedPortalId) return [];
      return this.topics.filter(topic => topic.portal_id === this.selectedPortalId);
    },
    selectedPortal() {
      return this.portals.find(portal => portal.id === this.selectedPortalId) || null;
    },

    portal_id() {
      return this.$route.params.portal_id;
    },
    isPublic() {
      return this.selectedVisibility === 'public';
    },
    isViewPortalPage() {
      return this.$route.name === 'view_portal';
    },
    filteredUsers() {

      const query = this.searchQuery?.toLowerCase() || '';

      // Determine the list to filter
      const sourceList = this.isViewPortalPage ? this.members : this.users;

      // If there is no search query, return the full list
      if (!query) {
        return sourceList;
      }

      // Filter by first name or last name
      return sourceList.filter(user =>
        (user.first_name && user.first_name.toLowerCase().includes(query)) ||
        (user.last_name && user.last_name.toLowerCase().includes(query))
      );
    },
    areAllSelected() {
      const filteredIds = this.filteredUsers.map(user => user.id);
      return filteredIds.every(id => this.selectedUserIds.includes(id)) && filteredIds.length > 0;
    },
    filteredPortals() {
      if (!this.searchQuery) {
        return this.portals.filter(portal =>
          !portal.portal_type || portal.portal_type.name !== 'incident'
        );
      }
      const query = this.searchQuery.toLowerCase();
      return this.portals.filter(portal =>
        (!portal.portal_type || portal.portal_type.name !== 'incident') &&
        portal.name.toLowerCase().includes(query)
      );
    },
    areAllSubPortalsSelected() {
      const filteredIds = (this.filteredPortals || []).map(portal => portal.id);
      return filteredIds.length > 0 && filteredIds.every(id => this.selectedPortals.includes(id));
    },
  },

  methods: {

    handle_drop(e) {
      this.isDragging = false;
      const files = e.dataTransfer.files;
      if (files.length > 0) {
        // Create a mock event to reuse your existing handleGroupFileUpload logic
        const mockEvent = { target: { files: files } };
        this.handleFileUpload(mockEvent);
      }
    },
    handle_edit_drop(e) {
      this.edit_isDragging = false;
      const files = Array.from(e?.dataTransfer?.files || []);
      this.add_edit_preview_files(files);
    },
    handleEditFileUpload(event) {
      const files = Array.from(event?.target?.files || []);
      this.add_edit_preview_files(files);
      this.edit_file_input_key += 1;
    },
    add_edit_preview_files(files = []) {
      files.forEach((file) => {
        this.edit_upload_files.push(file);
        const fileName = file.name || "";
        const fileType = file.type || "";
        let previewType = "file";
        if (fileType.startsWith("image/")) previewType = "image";
        if (fileType.startsWith("video/")) previewType = "video";

        this.edit_previews.push({
          name: fileName,
          type: previewType,
          src: previewType === "file" ? "" : URL.createObjectURL(file),
        });
      });
    },
    remove_edit_preview(index) {
      const [preview] = this.edit_previews.splice(index, 1);
      this.edit_upload_files.splice(index, 1);
      if (preview?.src) {
        URL.revokeObjectURL(preview.src);
      }
    },
    markEditFileForRemoval(fileId, index) {
      if (fileId && !this.edit_files_to_remove.includes(fileId)) {
        this.edit_files_to_remove.push(fileId);
      }
      this.edit_documents?.report_files?.splice(index, 1);
    },
    get_edit_report_file_url(fileObj) {
      return String(fileObj?.file?.file_url || fileObj?.file?.url || fileObj?.file_url || fileObj?.url || "");
    },
    get_edit_file_name(url = "") {
      return String(url).split("/").pop() || "File";
    },

    getPersonalProfileImage() {
      const files =
        this.activeProfile?.user?.profile?.profile_files || []

      const profilePic = files.find(
        f => f.profile_file_type === 'profile_picture'
      )

      return profilePic?.file?.url ?? null
    },

    getBusinessProfileImage() {
      const businessFiles =
        this.activeProfile?.company?.base_profile?.profile_files || []

      if (businessFiles.length) {
        return businessFiles[0]?.file?.file_url ?? null
      }

      return require('@/assets/images/user.png')
    },

    triggerAudioInput() {
      this.$refs.audioInputRef.click();
    },
    triggerFileInput() {
      this.$refs.fileInputRef.click();
    },

    openCategoryModal() {
      this.isCategoryModalOpenedFromFeed = true; // mark that we're switching modals
      $('#feed_modal').modal('hide');            // close feed modal
      $('#category_modal').modal('show');        // open category modal
    },
    openAuthorModal() {
      this.isCategoryModalOpenedFromFeed = true;
      $('#feed_modal').modal('hide');          // close feed modal
      $('#author_modal').modal('show');        // open author modal
    },
    openEditCategoryModal() {
      $('#edit_report_modal').modal('hide');
      $('#category_modal_edit').modal('show');
    },
    openEditAuthorModal() {
      $('#edit_report_modal').modal('hide');
      $('#author_modal_edit').modal('show');
    },
    addEditAuthor() {
      const name = (this.edit_author_input || '').trim();
      const link = (this.edit_author_link || '').trim();
      if (!name) return;
      this.edit_authors.push({
        author_name: name,
        author_link: link,
        link,
      });
      this.edit_author_input = '';
      this.edit_author_link = '';
    },
    removeEditAuthor(index) {
      this.edit_authors.splice(index, 1);
    },
    saveEditAuthors() {
      this.report_edit.authors = this.edit_authors;
      $('#author_modal_edit').modal('hide');
      $('#edit_report_modal').modal('show');
    },
    updateEditTagSelection(categoryId, tags) {
      this.edit_selected_tags.set(categoryId, tags);
      this.edit_selected_tags = new Map(this.edit_selected_tags);
    },
    selectEditPrimaryTag(categoryId, tag) {
      this.edit_primary_tags.clear();
      this.edit_primary_tags.set(categoryId, tag || null);
      this.edit_primary_tag = tag || null;

      let secondaryTags = this.edit_selected_tags.get(categoryId) || [];
      if (tag) {
        secondaryTags = secondaryTags.filter(t => t.id !== tag.id);
      }

      this.edit_selected_tags.set(categoryId, secondaryTags);
      this.edit_primary_tags = new Map(this.edit_primary_tags);
      this.edit_selected_tags = new Map(this.edit_selected_tags);
    },
    submit_edit_tags() {
      const selected = Array.from(this.edit_selected_tags.values()).flat();
      if (this.edit_primary_tag && !selected.find(tag => String(tag.id) === String(this.edit_primary_tag.id))) {
        selected.push(this.edit_primary_tag);
      }
      this.edit_selected_categories = selected;
    },
    updateTagSelection(categoryId, tags) {
      this.selected_tags.set(categoryId, tags);
    },

    addAuthor() {
      const name = this.authorName.trim();
      const link = this.authorLink.trim();

      if (!name) return; // Require name

      this.authors.push({
        author_name: name,
        author_link: link || ''
      });
      this.authorName = '';
      this.authorLink = '';
    },
    removeAuthor(index) {
      this.authors.splice(index, 1);
    },

    updateTagSelection(categoryId, newValue) {
      this.selected_tags.set(categoryId, newValue);
      // Force reactivity
      this.selected_tags = new Map(this.selected_tags);
    },
    resetPortalSelection() {
      this.selectedPortalId = '';
      this.selectedTopicId = '';
      this.errors.portal = '';
      this.errors.segment = '';
      this.errors.name = '';
      this.fileName = '';
      this.upload_media = null;
      this.imagePreview = null;
      this.videoPreview = null;
      this.uploaded_files = [];
      this.audio_file = null;
      this.audio_attachments = [];
      this.audio_file_name = '';
      this.fileError = '';
      this.report_description = '';
      this.description = '';
      this.selected_categories = [];
      this.selected_author = null;
      this.authorInput = '';
    },
    toggleDropdown() {
      this.isDropdownVisible = !this.isDropdownVisible;
    },
    handleCustomer() {
      const role = this.user_details.user_role
      if (role === 'user') {
        return false
      }
      else {
        return true
      }
    },
    fetch_portal_members() {
      this.members = [];

      if (!this.portal_id) return;

      this.isLoading = true;
      $.ajax({
        url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/get_portal_members/`,
        method: "GET",
        data: { portal_id: this.portal_id },
        headers: {
          "Authorization": `Token ${this.getToken()}`,
          "Content-Type": "application/json"
        },
        success: (response) => {
          if (response.status === "success") {
            this.members = response.data.members;
            setTimeout(() => {
              this.loading = false;
            }, 1000);
          }
        },
        error: (xhr) => {
          console.error("Error fetching portal members:", xhr);
        },
        complete: () => {
          this.isLoading = false;
        }
      });
    },
    selectPrimaryTag(categoryId, tag) {
      //  Get old primary BEFORE modifying the map
      this.primary_tags.clear();
      const oldPrimary = this.primary_tags.get(categoryId) || null;

      // Update primary tag only for this category
      this.primary_tags.set(categoryId, tag || null);
      this.primary_tag = tag || null;

      // 3️⃣ Refresh secondary tags for THIS category
      let secondaryTags = this.selected_tags.get(categoryId) || [];

      // Remove the new primary from secondary
      if (tag) {
        secondaryTags = secondaryTags.filter(t => t.id !== tag.id);
      }

      // Remove the old primary from secondary
      if (oldPrimary) {
        secondaryTags = secondaryTags.filter(t => t.id !== oldPrimary.id);
      }

      this.selected_tags.set(categoryId, secondaryTags);

      this.primary_tags = new Map(this.primary_tags);
      this.selected_tags = new Map(this.selected_tags);
    },

    reset_modal_data() {
      this.primary_tags = new Map();
      this.selected_tags = new Map();
      this.primary_tag = null;
      this.form = {};
    },


    toggleSelectAll() {
      const filteredIds = this.filteredUsers.map(user => user.id);
      if (this.areAllSelected) {

        this.selectedUserIds = this.selectedUserIds.filter(id => !filteredIds.includes(id));
      } else {
        this.selectedUserIds = [...new Set([...this.selectedUserIds, ...filteredIds])];
      }
    },
    toggleSelectAllSubPortals() {
      const filteredIds = (this.filteredPortals || []).map(portal => portal.id);

      if (this.areAllSubPortalsSelected) {
        this.selectedPortals = this.selectedPortals.filter(id => !filteredIds.includes(id));
      } else {
        this.selectedPortals = [...new Set([...this.selectedPortals, ...filteredIds])];
      }
    },
    preselectTagsFromFlatArray() {
      const preselected = this.existing_tags || []; // Flat array of tag objects

      preselected.forEach(tag => {
        const cat_id = tag.tag_category.id;
        if (this.selected_tags.has(cat_id)) {
          const current = this.selected_tags.get(cat_id) || [];
          current.push({ id: tag.id, name: tag.name });
          this.selected_tags.set(cat_id, current);
        }
      });

      // Force reactivity
      this.selected_tags = new Map(this.selected_tags);
    },
    fetch_grouped_tags() {
      this.isLoading = true;

      $.ajax({
        url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/get_all_tags/`,
        method: 'GET',
        headers: {
          'Authorization': `Token ${this.getToken()}`,
          'Content-Type': 'application/json'
        },
        success: (response) => {
          if (response.status === "success") {
            const tag_list = response.data.tags;

            // Group tags by category
            const grouped = new Map();

            tag_list.forEach(tag => {
              const cat_id = tag.tag_category.id;
              const categoryName = tag.tag_category.name;

              if (!grouped.has(cat_id)) {
                grouped.set(cat_id, {
                  id: cat_id,
                  name: categoryName,
                  tags: []
                });
              }

              grouped.get(cat_id).tags.push({
                id: tag.id,
                name: tag.name
              });
            });

            // Convert grouped Map to array
            this.grouped_tags = Array.from(grouped.values());

            // Initialize selected_tags and primary_tags Maps per category
            this.grouped_tags.forEach(cat => {
              this.selected_tags.set(cat.id, []);


            });


            this.preselectTagsFromFlatArray(); // Optional preselection logic
          }
        },
        complete: () => {
          this.isLoading = false;
        }
      });
    },

    submit_tags() {
      // Grab the selected primary tag
      const primaryTag = this.primary_tag || null;

      // Flatten all secondary tags into a single array
      this.selected_categories = Array.from(this.selected_tags.values()).flat();

      // If you need to include the primary tag in submission explicitly:
      if (primaryTag) {
        this.selected_categories.push(primaryTag);
      }

    },

    fecthPortalTypes() {
      this.isLoading = true;
      $.ajax({
        url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/get_portal_types`,
        method: 'GET',
        headers: {
          'Authorization': `Token ${this.getToken()}`,
          'Content-Type': 'application/json'
        },
        success: (response) => {
          var status = response.status
          if (status == "success") {
            this.portal_types = response.portal_types
          }
        },
        complete: () => {
          this.isLoading = false;
        }
      });
    },

    removeFile(index) {
      this.upload_files.splice(index, 1);
      this.previews.splice(index, 1);
    },

    handleFileUpload(event) {
      const files = Array.from(event.target.files);
      if (!files.length) return;

      this.fileError = null;

      const MAX_FILES = 10;
      if (files.length + this.upload_files.length > MAX_FILES) {
        this.fileError = `Maximum ${MAX_FILES} files allowed.`;
        this.file_input_key += 1;
        return;
      }

      files.forEach(file => {
        this.upload_files.push(file);

        // ✅ IMAGE PREVIEW
        if (file.type.startsWith("image/")) {
          const reader = new FileReader();
          reader.onload = e => {
            this.previews.push({
              type: "image",
              src: e.target.result,
              name: file.name
            });
          };
          reader.readAsDataURL(file);
        }

        // ✅ VIDEO PREVIEW
        else if (file.type.startsWith("video/")) {
          const url = URL.createObjectURL(file);
          this.previews.push({
            type: "video",
            src: url,
            name: file.name
          });
        }

        // ✅ DOCUMENT / OTHER FILE PREVIEW
        else {
          this.previews.push({
            type: "file",
            name: file.name,
            extension: file.name.split('.').pop().toLowerCase()
          });
        }
      });

      this.file_input_key += 1;
    },

    onPortalChange() {
      if (this.selectedPortalId) {
        this.fetch_topics(this.selectedPortalId);
      }
    },
    getToken() {
      return get_token();
    },
    canAddAudioAttachment() {
      if (this.audio_attachments.length < 10) return true;

      this.audioError = 'You can add up to 10 audio recordings.';
      return false;
    },
    addAudioAttachment(file, name) {
      if (!file || !this.canAddAudioAttachment()) return false;

      this.audio_attachments.push({
        file,
        name: name || file.name || `recording-${this.audio_attachments.length + 1}.wav`,
      });
      this.audio_file = this.audio_attachments[this.audio_attachments.length - 1].file;
      this.audio_file_name = this.audio_attachments[this.audio_attachments.length - 1].name;
      this.audioError = '';
      return true;
    },
    startRecording(event) {
      event.preventDefault();
      if (!this.canAddAudioAttachment()) return;

      this.recordedChunks = [];
      this.recordingTime = 0; // Reset timer before starting
      navigator.mediaDevices.getUserMedia({ audio: true })
        .then((stream) => {
          this.mediaRecorder = new MediaRecorder(stream);

          this.mediaRecorder.ondataavailable = (event) => {
            if (event.data.size > 0) {
              this.recordedChunks.push(event.data);
            }
          };

          this.mediaRecorder.onstop = () => {
            const audioBlob = new Blob(this.recordedChunks, { type: 'audio/wav' });
            this.addAudioAttachment(audioBlob, `recording-${this.audio_attachments.length + 1}.wav`);

            // Clear the timer
            clearInterval(this.timerInterval);
          };

          this.mediaRecorder.start();
          this.isRecording = true;

          // Start the timer ⏱
          this.timerInterval = setInterval(() => {
            this.recordingTime++;
          }, 1000);
        })
        .catch((error) => {
          console.error('Microphone error:', error);
          if (error.name === 'NotAllowedError') {
            Swal.fire({
              icon: 'error',
              title: 'Microphone Access Denied',
              text: 'Please allow microphone access in your browser settings and refresh the page.',
              position: 'bottom-end',
              showConfirmButton: false,
              timer: 3000,
              toast: true
            });
          }
        });
    },

    // Gracefully stop and optionally discard any in-progress recording
    cleanupRecording(discard = true) {
      if (this.mediaRecorder) {
        // If recording is active, optionally suppress onstop behavior when discarding
        if (this.isRecording) {
          if (discard) {
            // Suppress onstop behavior when discarding by clearing the handler
            this.mediaRecorder.onstop = null;
          }
          try { this.mediaRecorder.stop(); } catch (e) { /* ignore errors stopping recorder */ }
        }

        // Stop tracks if available
        try {
          if (this.mediaRecorder.stream && this.mediaRecorder.stream.getTracks) {
            this.mediaRecorder.stream.getTracks().forEach(track => track.stop());
          }
        } catch (e) { /* ignore */ }
      }

      // Clear timer
      if (this.timerInterval) {
        clearInterval(this.timerInterval);
        this.timerInterval = null;
      }

      this.isRecording = false;

      if (discard) {
        this.recordedChunks = [];
        this.audio_file = null;
        this.audio_file_name = '';
      }

      // Release mediaRecorder reference
      this.mediaRecorder = null;
    },

    stopRecording(event) {
      if (event && event.preventDefault) event.preventDefault();
      // Let the normal onstop handler run so recorded blob is created
      this.cleanupRecording(false);
    },
    clearAudioAttachment() {
      this.cleanupRecording(true);
      this.audio_attachments = [];
      this.audioError = '';
    },
    removeAudioAttachment(index) {
      this.audio_attachments.splice(index, 1);
      const latestAudio = this.audio_attachments[this.audio_attachments.length - 1];
      this.audio_file = latestAudio?.file || null;
      this.audio_file_name = latestAudio?.name || '';
      this.audioError = '';
    },

    handleAudioUpload(event) {
      const files = Array.from(event.target.files || []);

      if (files.length) {
        files.forEach(file => {
          if (!file.type.startsWith('audio/')) {
            this.audioError = 'Only audio files are allowed.';
          } else {
            this.addAudioAttachment(file, file.name);
          }
        });

        this.audio_input_key += 1;
      } else {
        this.audioError = '';
      }
    },
    fetchPortals() {
      this.isLoading = true;
      $.ajax({
        url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/get_all_portals_api/`,
        method: 'POST',
        headers: {
          'Authorization': `Token ${this.getToken()}`,
          'Content-Type': 'application/json'
        },
        data: JSON.stringify(this.payload),

        success: (data) => {
          if (this.user_details.user_role === "admin") {
            this.portals = data.portals;
            this.portals = this.portals.filter(
                  portal => portal.name?.toLowerCase() !== 'default portal'
                );

          } else {
            const portal = data.portals
            this.portals = portal.filter(portal => portal.has_access == "approved")

          }
        },
        complete: () => {
          this.isLoading = false;
        }
      });
    },
    fetch_users() {
      return new Promise((resolve) => {

        const groupId = this.$route.params.group_id;
        $.ajax({
          type: 'GET',
          data: { group_id: groupId },
          url: process.env.VUE_APP_BACKEND_API_URL + '/system_management/retrieve_users/',
          headers: {
            'Authorization': `Token ${this.getToken()}`,
          },
          success: (response) => {
            this.users = response.data.users_list.filter(user => user.id != this.user_details.user_id);
            resolve();
          },
        });
      });
    },
    fetch_topics(portal_id) {
      this.isLoading = true;
      $.ajax({
        url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/get_all_topics_api`,
        method: 'GET',
        headers: {
          'Authorization': `Token ${this.getToken()}`,
          'Content-Type': 'application/json'
        },
        data: { portal_id: portal_id },
        success: (response) => {
          var status = response.status
          if (status == "success") {
            this.topics = response.topics
          }
        },
        complete: () => {
          this.isLoading = false;
        }
      });
    },

    resetForm() {
      // Reset the Quill editor
      if (this.$refs.quillReportEditorRef?.quill) {
        this.$refs.quillReportEditorRef.quill.root.innerHTML = '';
      }

      // Reset any files or previews
      this.report_url = null;
      this.upload_media = null;
      this.audio_file = null;
      this.audio_attachments = [];
      this.fileName = "";
      this.fileError = "";
      this.imagePreview = null;
      this.videoPreview = null;
      this.previews.forEach((preview) => {
        if (preview?.src && preview.type === 'video') URL.revokeObjectURL(preview.src);
      });
      this.previews = [];
      this.upload_files = [];
      this.audio_file_name = '';
      this.authors = [];
      this.file_input_key += 1;
      this.audio_input_key += 1;
      // Reset error messages
      this.errors = {};

      // Reset dropdowns
      this.isDropdownVisible = false;
      this.selectedPortalId = "";
      this.selectedTopicId = "";
      this.selected_categories = [];
      this.linkPreview = null;
      this.report_link = null;
    },
    reset_edit_report_state() {
      this.report_edit = {};
      this.edit_report_id = null;
      this.edit_report_description = '';
      this.edit_report_link = '';
      this.edit_documents = {};
      this.edit_selected_topic = null;
      this.edit_authors = [];
      this.edit_author_input = '';
      this.edit_author_link = '';
      this.edit_selected_tags = new Map();
      this.edit_primary_tags = new Map();
      this.edit_primary_tag = null;
      this.edit_selected_categories = [];
      this.edit_files_to_remove = [];
      this.edit_previews.forEach((preview) => {
        if (preview?.src) URL.revokeObjectURL(preview.src);
      });
      this.edit_previews = [];
      this.edit_upload_files = [];
      this.edit_comments_off = true;
      this.audio_file = null;
      this.audio_attachments = [];
      this.audio_file_name = '';
      this.edit_file_input_key += 1;
      this.audio_input_key += 1;
    },
    open_edit_report(report) {
      this.reset_edit_report_state();
      this.report_edit = report || {};
      this.edit_report_id = report?.id || null;
      this.edit_report_link = report?.report_link || '';
      this.edit_documents = report || {};
      this.edit_selected_topic = report?.topic?.id || '';
      this.edit_comments_off = report?.can_comment ?? true;
      this.edit_authors = Array.isArray(report?.authors) ? [...report.authors] : [];

      if (this.$route.name === 'view_portal' || this.$route.name === 'publish_portal') {
        this.selectedPortalId = this.$route.params.portal_id || report?.portal?.id || '';
        this.fetch_topics(this.selectedPortalId);
      } else if (report?.portal?.id) {
        this.selectedPortalId = report.portal.id;
        this.fetch_topics(this.selectedPortalId);
      }

      if (report?.primary_tag?.tag_category?.id) {
        const catId = report.primary_tag.tag_category.id;
        this.edit_primary_tags.set(catId, report.primary_tag);
        this.edit_primary_tags = new Map(this.edit_primary_tags);
        this.edit_primary_tag = report.primary_tag;
      }

      if (Array.isArray(report?.tags)) {
        report.tags.forEach(tag => {
          const catId = tag?.tag_category?.id;
          if (!catId) return;
          if (!this.edit_selected_tags.has(catId)) this.edit_selected_tags.set(catId, []);
          const catTags = this.edit_selected_tags.get(catId);
          if (report.primary_tag && tag.id === report.primary_tag.id) {
            catTags.unshift({ id: tag.id, name: tag.name });
          } else {
            catTags.push({ id: tag.id, name: tag.name });
          }
          this.edit_selected_tags.set(catId, catTags);
        });
        this.edit_selected_tags = new Map(this.edit_selected_tags);
      }

      $('#edit_report_modal').modal('show');

      this.$nextTick(() => {
        const quillEditor = this.$refs.quillEditReportRef?.getQuill?.();
        if (quillEditor) {
          quillEditor.clipboard.dangerouslyPasteHTML(report?.description || '');
        }
      });
    },
    edit_report_data() {
      Swal.fire({
        title: 'Submitting...',
        text: 'Please wait while we process your request.',
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        }
      });

      this.isSubmitting = true;
      const formData = new FormData();
      const quillEditor = this.$refs.quillEditReportRef?.getQuill?.();
      this.edit_report_description = quillEditor ? quillEditor.root.innerHTML.trim() : this.edit_report_description;

      formData.append('description', this.edit_report_description);
      formData.append('can_comment', this.edit_comments_off);
      formData.append('report_id', this.edit_report_id);
      formData.append('authors', JSON.stringify(this.edit_authors || []));

      if (this.edit_report_link) {
        formData.append('report_link', this.edit_report_link);
      }
      this.audio_attachments.forEach(audio => {
        formData.append('file', audio.file, audio.name);
        formData.append('audio_file', audio.file, audio.name);
        formData.append('audio_files', audio.file, audio.name);
      });
      if (this.edit_selected_topic) {
        formData.append('topic_id', this.edit_selected_topic);
      }
      this.edit_files_to_remove.forEach(id => {
        formData.append('remove_file_ids', id);
      });
      this.edit_selected_tags.forEach(tagsArray => {
        tagsArray.forEach(tag => formData.append('tag_ids', tag.id));
      });
      if (this.edit_primary_tag) {
        formData.append('primary_tag_id', this.edit_primary_tag.id);
      }
      this.edit_upload_files.forEach(file => {
        formData.append('file', file);
      });

      $.ajax({
        type: 'POST',
        url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/update_report_api/`,
        data: formData,
        processData: false,
        contentType: false,
        headers: {
          'Authorization': `Token ${this.getToken()}`,
        },
        success: (response) => {
          if (response.status === 'success') {
            const updatedReport = response.updated_data;
            updatedReport.linkPreview = this.report_edit.linkPreview;
            updatedReport.report_link = this.edit_report_link;

            Swal.fire({
              icon: 'success',
              title: response.message,
              showConfirmButton: false,
              timer: 1000,
              position: 'bottom-end',
              toast: true
            }).then(() => {
              $('#edit_report_modal').modal('hide');
              this.$emit('report-updated', updatedReport);
              this.reset_edit_report_state();
            });
          }
        },
        error: (response) => {
          Swal.close();
          this.errors.report_details = response?.responseJSON?.message || 'Unable to update feed.';
        },
        complete: () => {
          this.isSubmitting = false;
        }
      });
    },

    validationFeedForm() {
      this.errors = {};
      let valid = true;

      if (!this.selectedTopicId) {
        this.errors.segment = "You must tag a segment.";
      }
      return valid;
    },
    prepareTemporaryPost() {
      this.temporaryPost = {
        report_name: this.report_name || "Feed",
        isTemp: true
      };
    },
    scrollToElementById(id) {
      const el = document.getElementById(id);
      if (el) el.scrollIntoView({ behavior: 'smooth', block: 'center' });
    },
    getQuillContent(quill) {
      let content = quill.root.innerHTML;
      return content.replace(
        /<span class="mention" data-value="([^"]*)"[^>]*>@[^<]*<\/span>/g,
        '@$1'
      );
    },

    fetchReportPreview(url) {
      $.ajax({
        url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/fetch_url_meta/`,
        type: 'POST',
        data: JSON.stringify({url:url}),
        headers: {
          Authorization: `Token ${get_token()}`,
          "Content-Type": "application/json"


        },
        success: (data) => {
          this.linkPreview = data;
          this.report_url = data.url;

        },

      });
    },
    shortenUrl(url) {
      const u = new URL(url);
      let shortUrl = u.origin + u.pathname;

      if (shortUrl.length > 200) {
        shortUrl = shortUrl.substring(0, 200);
      }

      return shortUrl;
    },
    createFormData(content) {
      const formData = new FormData();

      if (this.report_url) {
        formData.append('report_link', this.shortenUrl(this.report_url));
      }

      if (this.$route.name === 'view_portal' || this.$route.name === 'publish_portal') {
        this.selectedPortalId = this.$route.params.portal_id;
      }

      formData.append('portal_id', this.selectedPortalId);
      formData.append('can_comment', this.comments_off);

      const baseUrl = `${window.location.origin}/home`;
      const encodedReportUrl = encodeURI(`${baseUrl}?report_id=dynamic_placeholder`);
      formData.append('base_url', encodedReportUrl);

      if (this.selectedTopicId) {
        formData.append('topic_id', this.selectedTopicId);
      }

      if (this.tagged_users.length > 0) {
        this.tagged_users.forEach(user => {
          formData.append('tagged_users', user.id); // multiple form entries with same key
        });
      }

      formData.append('description', content);
      formData.append('is_public', this.isPublic);
      formData.append('can_comment', this.comments_off);
      formData.append('authors', JSON.stringify(this.authors));
      if (this.upload_files?.length) {
        this.upload_files.forEach(file => {
          formData.append("file", file);   // SAME KEY MULTIPLE TIMES ✅
        });
      }


      this.audio_attachments.forEach(audio => {
        formData.append("file", audio.file, audio.name);
        formData.append("audio_file", audio.file, audio.name);
        formData.append("audio_files", audio.file, audio.name);
      });

      const tag_objects = Array.from(this.selected_tags.values()).flat().filter(tag => tag.id && tag.id); // [{id:1,...}, {id:2,...}]
      tag_objects.forEach(tag => {
        formData.append('tag_ids', tag.id); // ✅ append only the ID
      });

      let primaryTag = null;
      this.primary_tags.forEach(tag => {
        if (tag) primaryTag = tag;
      });

      if (primaryTag) {
        formData.append('primary_tag_id', primaryTag.id); // ✅ append primary tag ID if selected
      }



      return formData;
    },
    handleFormSuccess(response) {
      if (response.status === "success") {
        // Emit event to parent
        this.$emit('new_report', response.report_file_data);

        // Scroll to the new post
        this.$nextTick(() => this.scrollToElementById(`post-${response.report_file_data.id}`));

        // Clear temporary data
        this.temporaryPost = null;
        this.resetPortalSelection();

        // ✅ Reset the form fields
        this.resetForm();

        // ✅ Hide the modal after successful save
        $('#feed_modal').modal('hide');

        // Show success message for specific route
        if (this.$route.name === 'view_topic') {
          Swal.fire({
            icon: 'success',
            title: 'Success!',
            text: 'Your report has been successfully submitted.',
            showConfirmButton: false,
            timer: 2000,
            position: 'bottom-end',
            toast: true
          });
        }
      }
    },

    handleFormError(xhr) {
      this.temporaryPost = null;
      this.$emit('remove_temp_post');
      let message = 'There was an issue with your form submission. Please try again later.';

      try {
        const errorResponse = JSON.parse(xhr.responseText);
        if (errorResponse.message) {
          message = errorResponse.message;
        }
      } catch (e) {
        console.error('Non-JSON response:', xhr.responseText);
      }

      Swal.fire({
        icon: 'error',
        title: 'Bad Request!',
        text: message,
        confirmButtonText: 'ok',
        position: 'bottom-end',
        showConfirmButton: false,
        timer: 3000,
        toast: true
      });
    },
    submit_form() {
      if (!this.validationFeedForm()) return;
      this.$emit('trigger_component')

      this.prepareTemporaryPost();

      // this.$nextTick(() => this.scrollToElementById('temp-post'));

      const quill = this.$refs.quillReportEditorRef?.quill;
      if (!quill) return;

      const content = this.getQuillContent(quill);

      if (!this.report_url && !this.upload_files.length && !this.audio_attachments.length && content.trim() === "<p><br></p>") {
        this.errors.report_details = "Please fill in at least one of the required fields";
        $('#feed_modal').modal('show');
        this.$emit('remove_temp_post');
        return;
      }

      const formData = this.createFormData(content);

      this.isSubmitting = true;
      this.$emit('new_temp_post', this.temporaryPost);


      $('#feed_modal').modal('hide');

      $.ajax({
        type: "POST",
        url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/create_report_api/`,
        data: formData,
        processData: false,
        contentType: false,
        headers: {
          'Authorization': `Token ${this.getToken()}`,
        },
        success: this.handleFormSuccess,
        error: this.handleFormError,
        complete: () => { this.isSubmitting = false; this.report_link = null; this.linkPreview = null; }
      });
    },

    initQuillEditor() {
      const editor = this.$refs.quillReportEditorRef;
      if (!editor || this.quill) return;

      const quill = new Quill(editor, {
        theme: 'snow',
        modules: {
          toolbar: [
            ['bold', 'italic', 'underline', 'strike'],
            ['blockquote', 'code-block'],
            [{ 'header': 1 }, { 'header': 2 }],
            [{ 'list': 'ordered' }, { 'list': 'bullet' }],
            [{ 'script': 'sub' }, { 'script': 'super' }],
            [{ 'indent': '-1' }, { 'indent': '+1' }],
            [{ 'direction': 'rtl' }],
            [{ 'size': ['small', false, 'large', 'huge'] }],
            [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
            [{ 'color': [] }, { 'background': [] }],
            [{ 'font': [] }],
            [{ 'align': [] }],
            ['clean']
          ],
          mention: {
            allowedChars: /^[A-Za-z0-9_]+$/,
            mentionDenotationChars: ['@'],
            source: (searchTerm, renderList) => {
              const matches = this.members
                .filter(member => {
                  const fullName = `${member.full_name}`.toLowerCase();
                  return fullName.includes(searchTerm.toLowerCase());
                })
                .map(member => ({
                  id: member.id,
                  value: `${member.full_name}`
                }));
              renderList(matches);
            },
            renderItem(item) {
              return `${item.value}`;
            }
          }
        },
        placeholder: 'Type your text here...',
      });

      // ✅ store globally on component
      this.quill = quill;
      editor.quill = quill;

      // ✅ REACTIVITY FIX
      quill.on('text-change', () => {
        const text = quill.getText().trim();

        // Vue 2 safe reactivity
        if (this.$set) {
          this.$set(this, 'quillContentLength', text.length);
        } else {
          this.quillContentLength = text.length;
        }

        // 🔽 keep your existing mention logic
        const lastAtSymbol = text.lastIndexOf('@');

        if (lastAtSymbol !== -1) {
          this.currentTagPosition = lastAtSymbol;
          this.showSuggestions = true;
        } else {
          this.showSuggestions = false;
        }
      });

      quill.on('mention-selected', (user) => {
        this.selectUser(user);
      });

      // URL paste preview
      quill.root.addEventListener('paste', (e) => {
        const pastedText = e.clipboardData.getData('text');
        const match = pastedText.match(/(https?:\/\/[^\s]+)/g);

        if (match && match[0]) {
          this.fetchReportPreview( match[0]);
        }
      });
    },


    filterUsers(query) {
      if (!query) {
        this.filteredUsers = this.users;
        return;
      }
      this.filteredUsers = this.users.filter(user => {
        const fullName = `${user.first_name} ${user.last_name}`.toLowerCase();
        return fullName.includes(query.toLowerCase());
      });
    },
    selectUser(user) {

      const quill = this.$refs.quillReportEditorRef.quill;

      const mentionText = `@${user.full_name}`;

      const beforeTag = this.description ? this.description.slice(0, this.currentTagPosition) : '';

      // Delete any current text after the "@" trigger

      const cursorPosition = this.currentTagPosition + mentionText.length;

      // Clear existing content (optional, adjust as needed)

      quill.deleteText(this.currentTagPosition, quill.getLength());

      // Insert the styled mention

      quill.insertText(this.currentTagPosition, mentionText, {

        color: '#0d6efd', // Bootstrap primary blue

        bold: true

      });

      // Optionally add a space after mention

      quill.insertText(this.currentTagPosition + mentionText.length, ' ');

      // Move cursor after inserted text

      quill.setSelection(this.currentTagPosition + mentionText.length + 1);

      // Update your description variable if needed (optional)

      if (!this.tagged_users.find(u => u.id === user.id)) {
        this.tagged_users.push({ id: user.id, name: user.full_name });
      }

      this.description = quill.root.innerHTML;

      this.$nextTick(() => {

        this.showSuggestions = false;

      });

    },


  },
};
